<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor" >
        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />


        <vs-button style="float: left;" :color="openTasksColor" :disabled="$store.state.openTasks.length === 0" @click="openTask" class="mr-2 pl-4 pr-4">
          {{$store.state.openTasks.length}}
        </vs-button>

        <!--<bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" />-->
        <vs-button style="float: left" icon="directions_car" type="border" color="success" @click="openStartTransportPrompt" class="mr-2"/>

        <!--<vs-button style="float: left" icon="restaurant" type="border" color="warning" @click="console.log('start meal')" class="mr-2"/>-->

        <vs-spacer/>
        <h1 v-if="$store.state.development">TEST</h1>
        <vs-spacer/>

        <!--<search-bar />

        <notification-drop-down />-->

        <profile-drop-down />

        <vs-button class="p-1 mr-3 ml-3" color="dark" type="border" @click="zoomIn">&nbsp;+&nbsp;</vs-button>
        <vs-button class="p-1 mr-3" color="dark" type="border" @click="zoomOut">&nbsp;-&nbsp;</vs-button>

        <i18n :display-text="false"/>

      </vs-navbar>
    </div>

    <vs-popup :title="$t('StartWithTransport')" :active.sync="activeStartTransportPrompt" style="z-index: 54000">
      <div>
        <vs-button :disabled="startTransportButtonDisabled" color="success" type="border" class="mt-6; mr-1" @click="startTransport">{{$t("StartWithTransport")}}</vs-button>
        <vs-divider/>
        <vs-checkbox class="mb-6" v-model="transportHome">{{$t("TransportHome")}}</vs-checkbox>
        <p>{{$t("StartPoint")}}</p>
        <vs-input :disabled="true" style="width: 100%" class="mb-6" v-model="vehicleLastTransport.destination"></vs-input>
        <p>{{$t("Destination")}}</p>
        <vs-input :disabled="transportHome" style="width: 100%" class="mb-6" v-model="destination"></vs-input>
        <p>{{$t("StartKilometers")}}</p>
        <vs-input type="number" style="width: 100%" class="mb-6" v-model="startTransportKilometers"></vs-input>
        <p>{{$t("Vehicle")}}</p>
        <vs-select class="selectExample mb-6 w-full" v-model="selectedTransportVehicle">
          <vs-select-item v-if="!$store.state.vehiclesInUse.includes(item.id)" :key="index" :value="item.id" :text="item.name" v-for="(item,index) in vehicles" />
        </vs-select>
        <p>{{$t("Passengers")}}</p>
        <vs-select autocomplete multiple class="selectExample w-full" v-model="selectedStartTransportUsers">
          <vs-select-item v-if="item.id !== $store.getters.userData.id" :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyUsers" />
        </vs-select>
        <p class="mt-6">{{$t("TransportType")}}</p>
        <vs-select autocomplete class="selectExample w-full" v-model="selectedTransportType">
          <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in transportTypes" />
        </vs-select>
        <p class="mt-6">{{$t("Comments")}}</p>
        <vs-textarea v-model="startTransportComment" class="w-full" />
      </div>
    </vs-popup>

  </div>
</template>


<script>
import Bookmarks            from "./components/Bookmarks.vue"
import I18n                 from "./components/I18n.vue"
import SearchBar            from "./components/SearchBar.vue"
import NotificationDropDown from "./components/NotificationDropDown.vue"
import ProfileDropDown      from "./components/ProfileDropDown.vue"

export default {
  name: "the-navbar-vertical",
  props: {
    navbarColor: {
      type: String,
      default: "#fff",
    },
  },
  components: {
    Bookmarks,
    SearchBar,
    NotificationDropDown,
    ProfileDropDown,
    I18n,
  },
  data() {
    return{
      activeStartTransportPrompt: false,
      selectedStartTransportUsers: [],
      vehicles: [],
      vehiclesInUse: [],
      selectedTransportVehicle: '',
      vehicleLastTransport: '',
      startTransportKilometers: '',
      destination: '',
      homeAddress: '',
      transportHome: true,
      transportTypes: [],
      selectedTransportType: '',
      startTransportComment: '',
      lastTaskOpen: undefined,
      lastTaskOpenIndex: undefined,
    }
  },
  computed: {
    startTransportButtonDisabled: function () {

      if(Number(this.startTransportKilometers) === 0 ) return true;
      if(this.selectedTransportVehicle.length === 0) return true;
      if(!this.transportHome && this.destination.length === 0) return true;
      for(let x = 0; x < this.vehicles.length; x++){
        if(this.vehicles[x].private_vehicle && this.vehicles[x].id === this.selectedTransportVehicle) return false;
      }
      if(this.vehicleLastTransport) {
        if(this.vehicleLastTransport.end_kilometers > 0) {
          if(Math.abs(this.vehicleLastTransport.end_kilometers - Number(this.startTransportKilometers))  > 9) return true;
        }
      }

      return false;
    },
    navbarColorLocal() {
      if(this.$store.state.development) return "#FA2425";
      return this.$store.state.theme === "dark" && this.navbarColor === "#fff" ? "#10163a" : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor() {
      return {'text-white': (this.navbarColor != '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor != '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth == "default")      return "navbar-default"
      else if (this.verticalNavMenuWidth == "reduced") return "navbar-reduced"
      else if (this.verticalNavMenuWidth)              return "navbar-full"
    },
    openTasksColor() {
      if (!this.$store.state.openTasks) return "warning";
      if(this.$store.state.openTasks.length === 0){
        return "danger"
      }else if (this.$store.state.openTasks.length === 1){
        return "success"
      }else{
        return "warning"
      }
    },
  },
  methods: {
    openStartTransportPrompt() {
      this.activeStartTransportPrompt = true;
      const thisIns = this;
      this.$http.get('/api/v1/vehicle/?type=selectable')
              .then(function (response) {
                thisIns.vehicles = response.data;

              })
              .catch(function (error) {
                thisIns.$vs.notify({
                  title:'Error',
                  position:'top-right',
                  text: error,
                  color:'danger',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'})
              });
    },
    openTask(){

      if(this.lastTaskOpen){

        if(this.lastTaskOpenIndex < this.$store.state.openTasks.length){

          if(this.$store.state.openTasks[this.lastTaskOpenIndex] === this.lastTaskOpen) {

            if(this.lastTaskOpenIndex + 1 < this.$store.state.openTasks.length) {

              this.lastTaskOpenIndex += 1;
              this.lastTaskOpen = this.$store.state.openTasks[this.lastTaskOpenIndex];
              if(!(this.$router.currentRoute.name === 'task' && this.$router.currentRoute.params.id === "" + this.lastTaskOpen)){
                this.$router.push({ name: 'task', params: { id: "" + this.lastTaskOpen} })
              }
              return

            }

          }

        }
      }

      this.lastTaskOpen = this.$store.state.openTasks[0];
      this.lastTaskOpenIndex = 0;
      if(!(this.$router.currentRoute.name === 'task' && this.$router.currentRoute.params.id === "" + this.lastTaskOpen)){
        this.$router.push({ name: 'task', params: { id: "" + this.lastTaskOpen} })
      }

    },
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
    },
    zoomIn() {
      this.$store.dispatch('zoomIn');
    },
    zoomOut(){
      this.$store.dispatch('zoomOut');
    },
    startTransport(){
      const thisIns = this;
      this.$http.post('/api/v1/transport/start', {
        company_users: this.selectedStartTransportUsers,
        task_id: 0,
        kilometers: Number(this.startTransportKilometers),
        vehicle_id: Number(this.selectedTransportVehicle),
        destination_is_home: this.transportHome,
        destination: this.destination,
        transport_type_id: Number(this.selectedTransportType),
        comment: this.startTransportComment
      }).then(function () {
        thisIns.$store.dispatch('updateTransportStarted', true);
        thisIns.activeStartTransportPrompt = false;
        thisIns.$nextTick(() => {
          thisIns.$router.push({ name: 'in-transit' });
          document.body.style.zoom = "100%";
        });



      }).catch(function (error) {
        thisIns.activeStartTransportPrompt = false;
        thisIns.$vs.notify({
          title:'Error',
          position:'top-right',
          text: error,
          color:'danger',
          iconPack: 'feather',
          icon:'icon-alert-circle'})
      });
    }

  },
  watch:{
    selectedTransportVehicle: function () {
      const thisIns = this;
      this.$http.get('/api/v1/transport/list/vehicle/' + this.selectedTransportVehicle + '/last')
              .then(function (response) {
                thisIns.vehicleLastTransport = response.data;

              })
              .catch(function (error) {
                thisIns.$vs.notify({
                  title:'Error',
                  position:'top-right',
                  text: error,
                  color:'danger',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'})
              });
    },
    transportHome: function () {
      if(this.transportHome){
        this.destination = this.homeAddress
      }else{
        this.destination = ""
      }
    },
  },
  created() {
    const thisIns = this;
    this.$http.get('/api/v1/vehicle/?type=selectable')
            .then(function (response) {
              thisIns.vehicles = response.data;

            })
            .catch(function (error) {
              thisIns.$vs.notify({
                title:'Error',
                position:'top-right',
                text: error,
                color:'danger',
                iconPack: 'feather',
                icon:'icon-alert-circle'})
            });

    this.$http.get('/api/v1/transport/home')
            .then(function (response) {
              thisIns.homeAddress = response.data;
              thisIns.destination = response.data
            })
            .catch(function (error) {
              thisIns.$vs.notify({
                title:'Error',
                position:'top-right',
                text: error,
                color:'danger',
                iconPack: 'feather',
                icon:'icon-alert-circle'})
            });

    this.$http.get('/api/v1/transport_type/')
            .then(function (response) {
              let list = [];
              for(let x = 0; x < response.data.length; x++){
                if(response.data[x].allow_manual_use) {
                  list.push(response.data[x]);
                  thisIns.selectedTransportType = response.data[x].id;
                }
              }
              thisIns.transportTypes = list
            })
            .catch(function (error) {
              thisIns.$vs.notify({
                title:'Error',
                text: error,
                color:'danger',
                iconPack: 'feather',
                icon:'icon-alert-circle'})
            });
  }
}
</script>

